import api from "src/api/axiosInstance";
import { setproduct } from "src/store/slices/product-slice";
import { store } from "src/store/store";

export const fetchProductsByCategory = async (activeCategory, limit) => {
  try {
    const response = await api.get(
      `/products-by-collection-type/${activeCategory}?page=1&limit=${limit}`
    );
    return response.data.status === 0 ? response.data.data : [];
  } catch (error) {
    console.error("Error fetching products:", error);
    return [];
  }
};

export const fetchCategoryProductsByDropdown = async (
  productCategory,
  sortOption,
  minPrice, maxPrice, inStock, outOfStock, categories
) => {
  try {   
    
    const payload = {
      collectionType: productCategory,
    };
    
    // Add sort option
    if (sortOption === "dsc") {
      payload.sortbydate = "desc";
    } else {
      payload.sortbyprice = sortOption;
    }
    
    // Add price filters if present
    if (minPrice) {
      payload.minPrice = parseInt(minPrice);
    }
    
    if (maxPrice) {
      payload.maxPrice = parseInt(maxPrice);
    }
    
    // Add stock status filters
    if (inStock) {
      payload.instock = true;
    } else if (outOfStock) {
      payload.instock = false;
    }
    
    if (categories && categories.length > 0) {
      payload["categories"] = categories;
    }

    const response = await api.post(`/products-filter?limit=800&page=1`,payload);
    return response.data.status === 0 ? response.data.data : [];
  } catch (error) {
    console.error("Error filtering products:", error);
    return null;
  }
};

export const fetchAllProducts = async () => {
  try {
    const response = await api.get(`/products?limit=800&page=1`);
    if (response.data) {
      const products = response.data.data || [];
      store.dispatch(setproduct(products));
      return products;
    }
    return [];
  } catch (error) {
    console.error("Error fetching products:", error);
    return [];
  }
};

export const fetchAllProdyctsByDropdown = async (sortOption) => {

  try {
    const response = await api.post(`/products-filter?limit=800&page=1`, {
      sortbyprice: `${sortOption}`,
    });
    return response.data.status === 0 ? response.data.data : [];
  } catch (error) {
    console.error("Error filtering products:", error);
    return null;
  }

};
